jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.mission-and-aims').length ) {
        let $ = jQuery;

        $('section.mission-and-aims .slides').each(function() {
            let $this = $(this);

            $this.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                pauseOnFocus: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                arrows: false,
                centerMode: true,
                centerPadding: '20px',
                infinite: true,
                rows: 0,
                swipeToSlide: true,
                respondTo: 'min',
                useCSS: false,
                easing: 'easeInBack',
                // touchMove: false,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1080,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 680,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $children = $(this).find(".slick-slide");

            $children.on('click', function(){
                $this.slick('slickGoTo', $(this).data('slick-index'));
            });

            $this.on('afterChange', function(event, slick, currentSlide, next) {
                $slide = $(slick.$slides.get(currentSlide));
                $newDesc = $slide.data('slide_description');
                $this.parents('.mission-and-aims').find(".slide-extras .slide-description .text").fadeOut();
                setTimeout(function () {
                    $this.parents('.mission-and-aims').find(".slide-extras .slide-description .text").text($newDesc).fadeIn();
                }, 500);
            });

            $arrows = $this.parents('.mission-and-aims').find(".slide-extras .arrow-holder");
            $arrows.on("click", function () {
                if($(this).hasClass('next')) {
                    $this.slick('slickNext');
                } else {
                    $this.slick('slickPrev');
                }
            });

        });




    }
});